import React, { useState } from "react";
import { Button, Menu, MenuItem } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useHistory } from "react-router-dom";
const ManufacturerDropdown = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const history = useHistory();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleRegisterClick = () => {
    handleClose();
    history.push("/register-manufacturer");
  };

  const handleManufacturerOverview = () => {
    handleClose();
    history.push("/manufacturer-overview");
  };

  return (
    <div>
      <Button
        id="machine-button"
        aria-controls={open ? "machine-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        color="inherit"
        endIcon={<ArrowDropDownIcon />}
      >
        Manufacturer
      </Button>
      <Menu
        id="machine-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "machine-button",
        }}
      >
        <MenuItem onClick={handleManufacturerOverview}>
          Manufacturer Overview
        </MenuItem>
        <MenuItem onClick={handleRegisterClick}>Register Manufacturer</MenuItem>
      </Menu>
    </div>
  );
};

export default ManufacturerDropdown;
